import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import { FC, memo } from 'react';

import { CatalogItem } from '../../components/CatalogItem';
import { ICatalogItem } from '../../shared/types/catalog-items';

interface IFavoriteItemsProps {
  items: ICatalogItem[] | any;
}

export const FavoriteItems: FC<IFavoriteItemsProps> = memo(({ items }) => {
  //Максимальная ширина экрана. Возвращает - true
  const mobileScreen = useMediaQuery('(max-width:900px)');
  return (
    <ul className={classNames('catalog-page-cards favorite grid')}>
      {items !== null &&
        items?.map((item: any, i: any) => {
          return (
            <CatalogItem
              key={`${item.id}_${i}`}
              screen={mobileScreen ? 'mobile' : 'desktop'}
              item={item}
              className="grid"
            />
          );
        })}
    </ul>
  );
});
